import { useState } from "react";

export const useOpen = (initialOpen = false) => {
  const [open, setOpen] = useState(initialOpen);

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleToggle = () => {
    setOpen((prev) => !prev);
  }

  return {
    open,
    handleOpen,
    handleClose,
    handleToggle
  };
}
